module.exports = __webpack_public_path__ + "assets/electrical-engineer.svg?6213540f4c85d49d63ee6ac5df0b6654";